function Section({ children }) {
  return (
    <section className="grid place-items-center h-screen text-gray-100">
      {children}
    </section>
  );
}

export default Section;
